import { EMPTY_ITEM_RIGHTS_COLLECTION } from "../../../../Global/Base/Rights/RightTypes";
import { invariant } from "../../../../Global/Base/Utils/AssertUtils";
import { GenericControlParams } from "./ControlInterfaces";
import { GenericControlCollection } from "./GenericControlCollection";
import { GenericPage, GenericPageTab } from "./GenericPage";
/**reprezentuje kontejner pro zalozky*/
export class GenericPages extends GenericControlCollection {
    //#region Fields
    public pages: GenericPage[];
    public pageTabs: GenericPageTab[];
    public selectedIndex: number;
    public selected: GenericPage;

    protected _pageContainer: HTMLDivElement;
    protected _tabStrip: HTMLUListElement;
    //#endregion Fields

    //#region Constructors
    constructor(params: GenericControlParams) {
        super(params);

        this.pageTabs = new Array<GenericPageTab>();

        this.pages = new Array<GenericPage>();

        this.element.classList.add("Pages");

        const divTabStrip = document.createElement("div");
        divTabStrip.classList.add("tabsDivContainer");
        this.element.appendChild(divTabStrip);

        this._tabStrip = document.createElement("ul");
        this._tabStrip.classList.add("tabsList");
        this._tabStrip.classList.add("ui-sortable");
        divTabStrip.appendChild(this._tabStrip);

        this._pageContainer = document.createElement("div");
        this.element.appendChild(this._pageContainer);
    }
    //#endregion Constructors

    public addPage(tabName: string, _key: string, locKey: string, element?: HTMLDivElement): GenericPage {
        // K 3. prosinci 2020 se addPage nikdy nevolá se zadaným elementem. Alespoň to tak vypadá.
        // Pro jistotu jsem kód nemazal, ale pouze tu dal invariant.
        // - Pokud to tu nebude padat, pak invariant smaž a refaktoruj odděláním parametru "element".
        // - Pokud to spadne, pak:
        //        - zjisti, odkud se to volá a přidej to do jsdoc
        //        - a nahraď EMPTY_ITEM_RIGHTS_COLLECTION za řádné načtení práv z "element"
        invariant(!element, "Element is not expected.");

        const header: GenericPageTab = new GenericPageTab(tabName, locKey);

        this.pageTabs.push(header);
        this._tabStrip.appendChild(header.element);

        let pageDiv: HTMLDivElement;

        if (element)
            pageDiv = element;
        else
            pageDiv = document.createElement("div");

        this._pageContainer.appendChild(pageDiv);

        const page = new GenericPage({
            element: pageDiv,
            header,
            originalRightsDefinition: EMPTY_ITEM_RIGHTS_COLLECTION,
        });

        this.pages.push(page);

        header.tabSelected.add((sender: GenericPageTab) => {
            this.selectPage(sender);
            this.selectPage(page);
        });

        return page;
    }

    public selectPage(page: GenericPageTab): void;
    public selectPage(page: GenericPage): void;
    public selectPage(page: any): void {
        if (page instanceof GenericPage) {
            this.pages.forEach((gp) => {
                gp.selected = gp.header.selected;
            });
        }

        if (page instanceof GenericPageTab) {
            const tab = page;

            this.pageTabs.forEach((_tab) => {
                if (_tab != tab) {
                    _tab.selected = false;
                }
            });
        }
    }

    //Nastavi prvni zalozku jako aktivni
    public selectFirst(): void {
        if (this.pages.length > 0)
            this.pages[0].header.selected = true;
    }

    public hidePage(page: GenericPageTab): void;
    public hidePage(page: GenericPage): void;
    public hidePage(page: any): void {
        this.selectFirst();

        if (page instanceof GenericPage)
            page.hide();
        /*
        if (page instanceof GenericPageTab) {
            var tab = <GenericPageTab>page;
        }
        */
    }

    public hideSelectedTab(): void {
        let i = 0;
        this.pages.forEach((_gp) => {
            if (_gp.selected && i > 0) {
                _gp.hide();
            }
            i++;
        });
        this.selectFirst();
    }

    public showPage(page: GenericPageTab): void;
    public showPage(page: GenericPage): void;
    public showPage(page: any): void {
        //this.SelectFirst();

        if (page instanceof GenericPage)
            page.show();
    }
}
